<script setup>
import { nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { calculateMarqueeMotion } from '../domain/marquee.js';

const props = defineProps({
  label: { type: String, default: '' },
  text: { type: String, default: '' },
  speed: { type: Number, default: 88 }
});

const viewport = ref(null);
const track = ref(null);
const animationKey = ref(0);
const ready = ref(false);
const motionStyle = ref({
  '--marquee-start': '0px',
  '--marquee-end': '0px',
  '--marquee-duration': '1s'
});
let resizeObserver = null;

async function measure() {
  await nextTick();
  const viewportWidth = viewport.value?.clientWidth || 0;
  const textWidth = track.value?.scrollWidth || 0;
  if (!viewportWidth || !textWidth) return;
  const motion = calculateMarqueeMotion({ viewportWidth, textWidth, speed: props.speed });
  motionStyle.value = {
    '--marquee-start': `${motion.start}px`,
    '--marquee-end': `${motion.end}px`,
    '--marquee-duration': `${motion.duration}s`
  };
  animationKey.value += 1;
  ready.value = true;
}

watch(() => [props.label, props.text, props.speed], measure);
onMounted(() => {
  resizeObserver = new ResizeObserver(measure);
  if (viewport.value) resizeObserver.observe(viewport.value);
  void measure();
});
onBeforeUnmount(() => resizeObserver?.disconnect());
</script>

<template>
  <div ref="viewport">
    <span :key="animationKey" ref="track" class="wanli-marquee-track" :class="{ 'is-ready': ready }" :style="motionStyle"><b v-if="label">{{ label }}</b>{{ text }}</span>
  </div>
</template>
